module.exports = __webpack_public_path__ + "img/registration_success.1310b294.png";